export default __webpack_public_path__ + "static/media/avatar.2e26e145.jpg";